import { createResponsiveStyles } from "../../utils";
import { theme } from "../../theme";
import ResponsiveStyleSheet from "react-native-media-query";
import { Platform } from "react-native";
export const { styles, ids } = ResponsiveStyleSheet.create({
    wrapper: {
        padding: 0,
        zIndex: 1,
        flex: 1,
    },
    portraitWrap: createResponsiveStyles({
        base: {
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            padding: theme.spacing.small,
            height: Platform.select({ web: "100%", default: undefined }),
        },
        medium: {
            paddingTop: theme.spacing.xlarge2,
        },
    }),
    landscapeWrap: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        paddingHorizontal: theme.spacing.small,
        alignContent: "center",
        alignItems: "center",
    },
    pillWrapper: {
        position: "absolute",
        top: -theme.spacing.small,
        alignItems: "center",
        left: 0,
        right: 0,
        zIndex: 2,
        elevation: 2,
    },
    heading: createResponsiveStyles({
        base: {
            textAlign: "center",
            paddingHorizontal: theme.spacing.xlarge,
        },
        small: {
            marginTop: theme.spacing.small,
        },
        medium: {
            flex: 1,
            marginBottom: theme.spacing.xlarge3,
            margin: 0,
        },
    }),
    button: {
        marginTop: theme.spacing.small,
    },
    children: {
        width: "100%",
        paddingHorizontal: theme.spacing.small,
        paddingBottom: theme.spacing.small,
    },
});
//# sourceMappingURL=CTA.styles.js.map